import React, { useEffect, useContext, useState } from "react";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardFooter from "beaktShared/components/Card/CardFooter.js";
import Button from "beaktShared/components/CustomButtons/Button.js";

//views
import CredenciamentoRanking from "./RelatoriosSistema/CredenciamentoRanking";
import RelatorioAnaliticoFechamento from "./RelatoriosSistema/RelatorioAnaliticoFechamento";
import RelatorioBoletimOcorrencia from "./RelatoriosSistema/RelatorioBoletimOcorrencia";
import RelatorioCreditosDebitos from "./RelatoriosSistema/RelatorioCreditosDebitos";
import RelatorioDividasClinicasFechadas from "./RelatoriosSistema/RelatorioDividasClinicasFechadas";
import RelatorioLogFechamento from "./RelatoriosSistema/RelatorioLogFechamento";
import RelatorioPagamentosUra from "./RelatoriosSistema/RelatorioPagamentosUra";
import RelatorioRankingFaturamento from "./RelatoriosSistema/RelatorioRankingFaturamento";
import RelatorioResumoVendaPorTipoPagamento from "./RelatoriosSistema/RelatorioResumoVendaPorTipoPagamento";
import RelatorioTicketMedio from "./RelatoriosSistema/RelatorioTicketMedio";
import RelatorioVendabyPacotes from "./RelatoriosSistema/RelatorioVendabyPacotes";
import RelatorioVendabyProdutos from "./RelatoriosSistema/RelatorioVendabyProdutos";
import RelatorioVendabyServicos from "./RelatoriosSistema/RelatorioVendabyServicos";
import RelatorioDetalhamentoContrato from "beaktClinic/views/Relatorios/RelatoriosSistema/RelatorioDetalhamentoContrato";
import RelatorioVendasByCliente from "beaktClinic/views/Relatorios/RelatoriosSistema/RelatorioVendasByCliente";
import RelatorioDemonstrativoAnual from "beaktClinic/views/Relatorios/RelatoriosSistema/RelatorioDemonstrativoAnual";

//services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

export default function RelatoriosSistemaList() {
  
  const session = useContext(SessionContext);

  const list_relatorios = [
    {
      tipo: "Vendas",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "relResumoVendasPorTipoPagamento", title: "Vendas Por Tipo Pagamento", description: "Relatório detalhado das vendas por tipos de pagamento", component: (<RelatorioResumoVendaPorTipoPagamento></RelatorioResumoVendaPorTipoPagamento>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByPacotes", title: "Vendas por Pacotes", description: "Relatório detalhado das vendas por pacotes.", component: (<RelatorioVendabyPacotes></RelatorioVendabyPacotes>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByProdutos", title: "Vendas por Produtos", description: "Relatório detalhado das vendas por produtos.", component: (<RelatorioVendabyProdutos></RelatorioVendabyProdutos>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosByServicos", title: "Vendas por Serviços", description: "Relatório detalhado das vendas por serviços.", component: (<RelatorioVendabyServicos></RelatorioVendabyServicos>) },
        { codigo: "relPermissao", codigoPermissao: "relPagamentosUra", title: "Pagamentos URA", description: "Relatório detalhado de pagamentos de vendas feitos pela URA.", component: (<RelatorioPagamentosUra></RelatorioPagamentosUra>) },
        { codigo: "relPermissao", codigoPermissao: "relDetalhamentoContrato", title: "Detalhamento Contrato", description: "Relatório detalhado contendo detalhamento de contratos vendidos", component: (<RelatorioDetalhamentoContrato></RelatorioDetalhamentoContrato>) },
        { codigo: "relPermissao", codigoPermissao: "relVendasCliente", title: "Vendas por Cliente", description: "Relatório detalhado de vendas por cliente", component: (<RelatorioVendasByCliente></RelatorioVendasByCliente>) }
      ]
    },
    {
      tipo: "Financeiro",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "relatorioanaliticofechamento", title: "Analítico Fechamento", description: "Relatório detalhado de fechamento.", component: (<RelatorioAnaliticoFechamento></RelatorioAnaliticoFechamento>) },
        { codigo: "relPermissao", codigoPermissao: "relCreditosDebitos", title: "Créditos e Débitos", description: "Relatório detalhado dos créditos e débitos.", component: (<RelatorioCreditosDebitos></RelatorioCreditosDebitos>) },
        { codigo: "relPermissao", codigoPermissao: "relatoriologfechamento", title: "Log Fechamento", description: "Relatório detalhado com logs de fechamentos de Royalties.", component: (<RelatorioLogFechamento></RelatorioLogFechamento>) },
        { codigo: "relPermissao", codigoPermissao: "relDividasClinicasFechadas", title: "Dívidas Estabelecimentos Fechados", description: "Relatório detalhado das clínicas que foram fechadas.", component: (<RelatorioDividasClinicasFechadas></RelatorioDividasClinicasFechadas>) },
        { codigo: "relPermissao", codigoPermissao: "relRankingFaturamento", title: "Ranking Faturamento", description: "Relatório detalhado com ranking de faturamento dos estabelecimentos.", component: (<RelatorioRankingFaturamento></RelatorioRankingFaturamento>) },
        { codigo: "relPermissao", codigoPermissao: "relTicketMedio", title: "Ticket Médio", description: "Relatório detalhado tickets médio.", component: (<RelatorioTicketMedio></RelatorioTicketMedio>) },
      ]
    },
    {
      tipo: "Outros",
      relatorios: [
        { codigo: "relPermissao", codigoPermissao: "rankingcredenciamento", title: "Credenciamento Ranking", description: "Relatório detalhado contendo um ranking dos estabelecimentos.", component: (<CredenciamentoRanking></CredenciamentoRanking>) },
        { codigo: "relPermissao", codigoPermissao: "relBoletimOcorrencia", title: "Boletins Ocorrência", description: "Relatório detalhado de boletins ocorrência.", component: (<RelatorioBoletimOcorrencia></RelatorioBoletimOcorrencia>) },
        { codigo: "relPermissao", codigoPermissao: "relDemonstrativoAnual", title: "Demonstrativo Anual", description: "Relatório detalhado contendo dados de faturamento anual", component: (<RelatorioDemonstrativoAnual></RelatorioDemonstrativoAnual>) },
      ]
    },
  ];

  const [relatorio, set_relatorio] = useState(null);

  const handleRelatorio = (item) => {
    set_relatorio(item.component);
  }

  const [relatoriosPermitidos, set_relatoriosPermitidos] = useState([])

  const loadRelatoriosPermitidos = () => {
    if (session.tipoPerfil == 0){
      set_relatoriosPermitidos(list_relatorios);
      return;
    }
    UseGetApiSimple("usuarios/getpermissoes/" + session.estabelecimentoId + "/" + session.id, "").then(result => {      
      if (result.status != 200){ 
        // INCLUIR MENSAGEM DE ERRO
        return;
      }
      let _relatoriosPermitidos = [];

      list_relatorios.map((m) => {
        let _relatorios = [];
        m.relatorios.map((n) => {
          if (result.data.filter(f => f.path == n.codigoPermissao && f.liberado).length > 0)
            _relatorios.push(n);
        })
        if (_relatorios.length > 0)
          _relatoriosPermitidos.push({
            tipo: m.tipo,
            relatorios: _relatorios
          });
      })

      set_relatoriosPermitidos(_relatoriosPermitidos);
    });    
  }

  useEffect(() => {
    loadRelatoriosPermitidos();
  }, []);

  return (
    <>
      {relatorio == null &&
        <div className="content">
          {relatoriosPermitidos.map((m, key) => (
            <div key={key} className="mt-4">
              <div className="subTitulo" style={{ marginTop: '20px', marginBottom: '0px' }}>
                <h6>{m.tipo}</h6>
              </div>
              <GridContainer>
                {m.relatorios.map((n, key2) => (
                  <GridItem key={key2} lg="4" md="6" sm="12">
                    <Card>
                      <CardBody className="rel-card-body">
                        <h5><strong>{n.title}</strong></h5>
                        {n.description}
                      </CardBody>
                      <CardFooter className="text-right">
                        <Button color="info" onClick={() => handleRelatorio(n)} className="btn-mobile">Visualizar Relatório</Button>
                      </CardFooter>
                    </Card>
                  </GridItem>
                ))}
              </GridContainer>
            </div>
          ))}
        </div>
      }
      {
        relatorio != null &&
        <>
          <GridContainer>
            <GridItem lg="12">
              <Button color="primary" onClick={() => set_relatorio(null)} className="btn-mobile">Voltar</Button>
            </GridItem>
          </GridContainer>
          {relatorio}
        </>
      }
    </>
  );
}
